import type { SceneCharacterFigure } from "@/lib/location-scene-3d/character-figure"
import { CHARACTER_FIGURES } from "@/lib/location-scene-3d/character-figures"
import { cn } from "@/lib/utils"

type HeroFigurePickerProps = {
  value: SceneCharacterFigure
  labelFor: (figure: SceneCharacterFigure) => string
  onPick: (figure: SceneCharacterFigure) => void
}

export function HeroFigurePicker({ value, labelFor, onPick }: HeroFigurePickerProps) {
  return (
    <div className="flex w-max flex-col gap-0.5 rounded-lg bg-black/55 p-0.5">
      {CHARACTER_FIGURES.map((item) => {
        const Icon = item.icon
        const active = item.id === value
        const label = labelFor(item.id)
        return (
          <button
            key={item.id}
            type="button"
            aria-label={label}
            aria-pressed={active}
            className={cn(
              "flex h-8 items-center gap-2 rounded-md px-2 text-left text-sm whitespace-nowrap text-white/85",
              "hover:bg-white/20 hover:text-white",
              active && "bg-white/20 text-white",
            )}
            onClick={() => onPick(item.id)}
          >
            {item.mark ? (
              <span className="inline-flex h-4 w-4 shrink-0 items-center justify-center text-xs font-medium">
                {item.mark}
              </span>
            ) : Icon ? (
              <Icon className="h-4 w-4 shrink-0" />
            ) : null}
            <span>{label}</span>
          </button>
        )
      })}
    </div>
  )
}
